'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/es-errors/eval.js
// module id = ../../../../es-errors/eval.js
// module chunks = 5